import React from 'react';

const DisclaimerModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>Official Giveaway Terms & Privacy Disclaimer</h2>
            <button className="modal-close" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>
          
          <div className="modal-body">
            <p>By submitting your story, you agree to the following terms:</p>
            
            <h3>Privacy & Data Use</h3>
            <p>
              Your name and email will never be shared, sold, or published. They will be used solely 
              for the purpose of prize delivery and communication related to this campaign.
            </p>

            <h3>Anonymous Stories</h3>
            <p>
              We may share or publish your submitted story for marketing or promotional purposes, but 
              your personal identity will not be revealed. If you include a name, alias, or other 
              identifying details in your story, we may edit or remove those details to protect your privacy.
            </p>

            <h3>Sensitive Information</h3>
            <p>
              Please do not include any personal data, such as your wallet ID, private keys, seed phrases, 
              account numbers, or any information that could be used to access your digital or financial assets. 
              Submissions containing such data will be immediately deleted and disqualified from the giveaway.
            </p>

            <h3>Eligibility & Prize Terms</h3>
            <p>
              At the end of each month, one eligible entry will be selected at random to receive a free 
              PhēnixLoc plan. No purchase necessary. Open to individuals aged 18 and older. Odds of winning 
              depend on the number of eligible entries received.
            </p>

            <h3>Notification & Claiming Prizes</h3>
            <p>
              The winner will be notified by email and must respond within 7 days to claim their prize. 
              Unclaimed prizes may be forfeited or redrawn at PhēnixLoc's discretion.
            </p>

            <h3>Rights & Modifications</h3>
            <p>
              By submitting your story, you grant PhēnixLoc a non-exclusive, royalty-free license to use, 
              edit, and share your story (anonymously) across our marketing channels. PhēnixLoc reserves 
              the right to modify, suspend, or cancel this campaign at any time for any reason.
            </p>

            <h3>Compliance</h3>
            <p>
              This campaign is void where prohibited by law and subject to all applicable local regulations.
            </p>
          </div>

          <div className="modal-footer">
            <button className="modal-button" onClick={onClose}>
              I Understand
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
        }

        .modal-content {
          background: white;
          border-radius: 12px;
          max-width: 700px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 24px 24px 16px;
          border-bottom: 1px solid #e5e7eb;
        }

        .modal-header h2 {
          margin: 0;
          font-size: 24px;
          font-weight: 600;
          color: #00CC5C;
        }

        .modal-close {
          background: none;
          border: none;
          font-size: 32px;
          line-height: 1;
          cursor: pointer;
          color: #6b7280;
          padding: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          transition: all 0.2s;
        }

        .modal-close:hover {
          background-color: #f3f4f6;
          color: #111827;
        }

        .modal-body {
          padding: 24px;
        }

        .modal-body p {
          margin: 0 0 16px;
          color: #374151;
          line-height: 1.6;
        }

        .modal-body h3 {
          margin: 24px 0 12px;
          font-size: 18px;
          font-weight: 600;
          color: #111827;
        }

        .modal-body h3:first-of-type {
          margin-top: 0;
        }

        .modal-footer {
          padding: 16px 24px 24px;
          display: flex;
          justify-content: center;
        }

        .modal-button {
          background-color: #00CC5C;
          color: white;
          border: none;
          padding: 12px 32px;
          font-size: 16px;
          font-weight: 500;
          border-radius: 8px;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .modal-button:hover {
          background-color: #00a64a;
        }

        @media (max-width: 768px) {
          .modal-content {
            max-height: 95vh;
          }

          .modal-header h2 {
            font-size: 20px;
          }

          .modal-body {
            padding: 20px;
          }

          .modal-body h3 {
            font-size: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default DisclaimerModal;